export default __webpack_public_path__ + "static/media/promotionFullBanner2.9a4eee34.png";